// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-comtrade{
    background: #fff;
    padding: 20px;
}
.btn {
    cursor: pointer;
    font-size: 12px;
    line-height: 14px;
    display: flex;
    padding: 5px;
    justify-content: center;
    width: calc(100% / 2 - 20px);
    color: #fff;
    background: linear-gradient(180deg, #2D72D2 0%, #345DA2 100%), linear-gradient(0deg, #345CA1, #345CA1);
    border-radius: 3px;
    border-width: 1px;
    border-color: #345CA1;
    border-style: solid;
}
#comptrade-btn-apply{
    margin-top: 10px;
    width: 100%;
}
#comptrade-upload{
    margin: 10px 0;
}
#title-format-comtrade{
    margin: 10px 0 6px 0;
}`, "",{"version":3,"sources":["webpack://./src/controls/trend/comtrade/comtrade.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,4BAA4B;IAC5B,WAAW;IACX,sGAAsG;IACtG,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,oBAAoB;AACxB","sourcesContent":[".container-comtrade{\r\n    background: #fff;\r\n    padding: 20px;\r\n}\r\n.btn {\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n    line-height: 14px;\r\n    display: flex;\r\n    padding: 5px;\r\n    justify-content: center;\r\n    width: calc(100% / 2 - 20px);\r\n    color: #fff;\r\n    background: linear-gradient(180deg, #2D72D2 0%, #345DA2 100%), linear-gradient(0deg, #345CA1, #345CA1);\r\n    border-radius: 3px;\r\n    border-width: 1px;\r\n    border-color: #345CA1;\r\n    border-style: solid;\r\n}\r\n#comptrade-btn-apply{\r\n    margin-top: 10px;\r\n    width: 100%;\r\n}\r\n#comptrade-upload{\r\n    margin: 10px 0;\r\n}\r\n#title-format-comtrade{\r\n    margin: 10px 0 6px 0;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
